import Box from '@redbubble/design-system/src/Box';
import InfoDiscIcon from '@redbubble/design-system/src/Icons/InfoDisc';
import Text from '@redbubble/design-system/src/Text';
import {
  defineMessages,
  FormattedMessage,
  useIntl,
} from '@redbubble/next/intl';
import React, { ReactNode, useState } from 'react';
import styles from './SEOTagsCover.module.scss';

const messages = defineMessages({
  hideTags: {
    defaultMessage: 'Hide product tags',
  },
  showTags: {
    defaultMessage: 'Show product tags',
  },
});

export interface SEOTagsCoverProps {
  tags?: string[];
  matureContent: boolean;
  disableSeoTag?: boolean | null;
  children: ReactNode;
}

export const SEOTagsCover: React.FC<SEOTagsCoverProps> = ({
  tags,
  matureContent,
  disableSeoTag,
  children,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <Box className={styles.container}>
      {!disableSeoTag && tags && tags?.length > 0 && (
        <>
          <button
            type="button"
            className={[
              styles.infoIcon,
              matureContent && styles.matureContent,
            ].join(' ')}
            title={intl.formatMessage(
              open ? messages.hideTags : messages.showTags
            )}
            onClick={(ev) => {
              ev.preventDefault();
              setOpen(!open);
            }}
          >
            <InfoDiscIcon size="small" className={styles.icon} />
          </button>

          <Box
            className={[
              styles.tagsContainer,
              matureContent && styles.matureContent,
              !open && styles.closed,
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <Box className={styles.content}>
              <Box className={styles.textContent}>
                <Text muted>
                  <strong>
                    <FormattedMessage defaultMessage="Tags:" />
                  </strong>
                  {` ${tags.join(', ')}`}
                </Text>
              </Box>
            </Box>
          </Box>
        </>
      )}
      {children}
    </Box>
  );
};
